import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiSearch, FiShoppingCart } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
    const navigate = useNavigate();
    const { cart } = useAuth();
    const [query, setQuery] = useState('');

    const handleSearch = (e) => {
        e.preventDefault();
        const trimmed = query.trim();
        if (trimmed) {
            navigate(`/search?q=${encodeURIComponent(trimmed)}`);
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <div className="navbar-brand">
                    <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <h1>ADITI TEXTILE</h1>
                    </Link>
                </div>

                <form className="search-box" onSubmit={handleSearch}>
                    <button type="submit" className="search-icon-btn" aria-label="Search">
                        <FiSearch className="search-icon" />
                    </button>
                    <input
                        type="text"
                        placeholder="What are you looking for?"
                        className="search-input"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                </form>

                <button type="button" className="cart-icon" onClick={() => navigate('/cart')} aria-label="Cart">
                    <FiShoppingCart size={24} />
                    <span className="cart-badge">{cart.length}</span>
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
